export default __webpack_public_path__ + "static/media/bug-logo-min.3d979797.svg";